import { KpiCard, KpiGrid } from '@/shared/components/dashboard/KpiCard';
import { Icons } from '@/shared/components/ui/icons';
import { useTranslation } from 'react-i18next';
import type { SubscriptionEventKpis } from '../types';

interface SubscriptionEventKpiCardsProps {
  kpis: SubscriptionEventKpis;
}

function KpiSkeleton() {
  return (
    <div className="rounded-xl border border-border bg-card p-5 animate-pulse">
      <div className="h-3 w-24 rounded bg-muted" />
      <div className="mt-3 h-8 w-16 rounded bg-muted" />
    </div>
  );
}

export function SubscriptionEventKpiCardsSkeleton() {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-6">
      {Array.from({ length: 6 }).map((_, index) => (
        <KpiSkeleton key={index} />
      ))}
    </div>
  );
}

export function SubscriptionEventKpiCards({ kpis }: SubscriptionEventKpiCardsProps) {
  const { t } = useTranslation();

  return (
    <KpiGrid className="gap-4 xl:grid-cols-3 2xl:grid-cols-6">
      <KpiCard
        title={t('subscriptionEvents.kpi.totalEvents')}
        value={String(kpis.totalEvents)}
        tone="blue"
        icon={<Icons.BarChart className="h-4 w-4" aria-hidden />}
      />
      <KpiCard
        title={t('subscriptionEvents.kpi.trialEvents')}
        value={String(kpis.trialEvents)}
        tone="cyan"
        icon={<Icons.Timer className="h-4 w-4" aria-hidden />}
      />
      <KpiCard
        title={t('subscriptionEvents.kpi.subscriptionEvents')}
        value={String(kpis.subscriptionEvents)}
        tone="violet"
        icon={<Icons.Repeat className="h-4 w-4" aria-hidden />}
      />
      <KpiCard
        title={t('subscriptionEvents.kpi.paymentEvents')}
        value={String(kpis.paymentEvents)}
        tone="amber"
        icon={<Icons.DollarSign className="h-4 w-4" aria-hidden />}
      />
      <KpiCard
        title={t('subscriptionEvents.kpi.entitlementEvents')}
        value={String(kpis.entitlementEvents)}
        tone="green"
        icon={<Icons.CheckCircle className="h-4 w-4" aria-hidden />}
      />
      <KpiCard
        title={t('subscriptionEvents.kpi.last30DaysEvents')}
        value={String(kpis.last30DaysEvents)}
        tone="rose"
        icon={<Icons.RefreshCw className="h-4 w-4" aria-hidden />}
      />
    </KpiGrid>
  );
}
